import { combineReducers } from 'redux-immutable'
import leaveRequestCreateReducer from './leave-request-create-reducer'
import leaveRequestGetReducer from './leave-request-get-reducer'
import leaveRequestPreviewReducer from './leave-request-preview-reducer'
import leaveRequestApproveReducer from './leave-request-approve-reducer'
import leaveRequestCancelReducer from './leave-request-cancel-reducer'

export default combineReducers({
  leaveRequestCreate: leaveRequestCreateReducer,
  leaveRequestGet: leaveRequestGetReducer,
  leaveRequestPreview: leaveRequestPreviewReducer,
  leaveRequestApprove: leaveRequestApproveReducer,
  leaveRequestCancel: leaveRequestCancelReducer,
})



// WEBPACK FOOTER //
// ./src/reducers/leave-request/index.js